import './styles/graphic.scss';
import { Child } from 'pym.js';

// Use whatever you like
const _ = {};
_.assign = require('lodash.assign');

const d3 = _.assign({},
  require('d3-selection'));

const stateChoices = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Washington, D.C.', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
const raceChoices = ['an Asian', 'a Black', 'an Indigenous', 'a Latino', 'a Pacific Islander',	'a White'];
const translate = {
  'an Asian': 'asian',
  'a Black': 'black',
  'an Indigenous': 'indigenous',
  'a Latino': 'latino',
  'a Pacific Islander': 'pacific_islander',
  'a White': 'white',
};
const rTranslate = {
  asian: 'Asian',
  black: 'Black',
  indigenous: 'Indigenous',
  latino: 'Latino',
  pacific_islander: 'Pacific Islander',
  white: 'White',
};
const userChoices = {};

window.pymChild = new Child();
const { pymChild } = window;

// Cleaning data
// d3.csv('./covid.csv', (d) => {
//   console.log(d);
//   return {
//     state: d.state,
//     values: {
//       asian: d.asian == '' ? 'NA' : d.asian,
//       black: d.black == '' ? 'NA' : d.black,
//       indigenous: d.indigenous == '' ? 'NA' : d.indigenous,
//       latino: d.latino == '' ? 'NA' : d.latino,
//       pacific_islander: d.pacific_islander == '' ? 'NA' : d.pacific_islander,
//       white: d.white == '' ? 'NA' : d.white,
//     },
//     notes: d.notes,
//   };
// }).then((d) => {
//   console.log('Data:', d);
// });

export default function (props, container, isMobile, data) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;

  // Add all options to select tags
  // State selection options
  d3.select('#state_select').selectAll('option').data(stateChoices).enter()
    .append('option')
    .attr('value', d => d)
    .html(d => d);
  // Race selection options
  d3.select('#race_select').selectAll('option').data(raceChoices).enter()
    .append('option')
    .attr('value', d => d)
    .html(d => d);

  // Add event listeners to each selection
  d3.selectAll('select').on('change', update);


  // Update users choices
  function update() {
    // Store each value and push to our user's choice array
    const selections = d3.select('.selectWrapper').selectAll('select').nodes();

    // For each selection store it in our choices object
    selections.forEach((d, i) => {
      // Store the key value to make our object
      const key = (d3.select(d).node().id).split('_')[0];

      // Store the user input as val
      let val = d3.select(d).node().value;

      // Change the name of the value, so it's readable by our script
      // If it's a state name, it doesn't need translating
      val = key == 'state' ? val : translate[val];

      // Add key/value pair to our user choice object
      userChoices[key] = val;
    });

    drawResults();
  }

  function drawResults() {
    // Response robotext
    let response = '';
    // User data
    let stateData = findStateObj(userChoices.state);
    const sValues = stateData.values;
    // US Level data
    const USData = findStateObj('US');
    // Conditionals for State/National level data
    let region = '';
    let likelihood = '';

    // Logic for checking REGION for one's race and state
    //
    // Check if selections valid
    if (stateData == undefined) {
    }
    // Check if there are rates for white people
    else if (sValues.white === 'NA') {
      response += `There\'s not enough granular data to determine these disparities in ${userChoices.state}. But from a national perspective, ${rTranslate[userChoices.race]} Americans are `;
      region = 'national';
      stateData = USData;
    }
    // Check if the values for user's chosen race are null
    else if (sValues[userChoices.race] === 'NA') {
      response += `There\'s not enough granular data to determine these disparities in ${userChoices.state}. But from a national perspective, ${rTranslate[userChoices.race]} Americans are `;
      region = 'national';
      stateData = USData;
    }
    // If the above factors don't impact, then we can do a statewide analysis
    else {
      response += `${rTranslate[userChoices.race]} Americans are `;
      region = 'state';
    }

    // IF poc
    //
    if (userChoices.race !== 'white') {
      // Calculate the likelihood difference POC
      if (region == 'state') {
        likelihood = calcLikelihood(sValues[userChoices.race], sValues.white);
      } else {
        likelihood = calcLikelihood(USData.values[userChoices.race], USData.values.white);
      }
    } else {
      // IF white
      //
      // Calculate the differences in area for all races
      //
      // Count NA's in data set
      let NACount = 0;
      for (const key in stateData.values) {
        const val = stateData.values[key];
        NACount += val === 'NA' ? 1 : 0;
      }

      // If there's not enough local data then:
      if (NACount >= (raceChoices.length - 1)) {
        response = `There\'s not enough granular data to determine these disparities in ${userChoices.state}. Across the US, White people are <span class="less times-diff">less likely</span> to die from Covid-19. <br><br> But from a national perspective, `;
        region = 'national';
        stateData = USData;
      // Else, populate text for state data:
      } else {
        response = `White Americans experience less risk than minorities in ${stateData.state}. `;
        region = 'state';
      }

      // Populate response:
      for (const key in stateData.values) {
        const val = stateData.values[key];
        if (val != 'NA' && key != 'white') {
          likelihood = calcLikelihood(val, stateData.values.white);
          response += `${rTranslate[key]} Americans are ${likelihoodText(likelihood)} to die from Covid-19. `;
        }
      }
    }

    // Draw function for returning a value
    //
    d3.select('.results_container').classed('hidden', false);
    d3.select('#results')
    // Results vary on input
      .html(() => {
        if (userChoices.race === 'white') {
          return `${response}`;
        }
        return `${response + likelihoodText(likelihood)} to die from Covid-19 in ${region === 'national' ? 'the' : ''} ${stateData.state}.`;
      });
    // Add footnote
    const footnote = d3.select('.footnote');
    footnote.classed('hidden', false);
    footnote.html(() => `Notes: ${stateData.notes}`);


    // Fix height
    pymChild.sendHeight();
  }

  // Returns the object given the state's name is correct
  function findStateObj(name) {
    return data.filter(obj => obj.state == name)[0];
  }
  // Calculate times likelihood
  // and round to nearest tenth
  function calcLikelihood(race, white) {
    const ratio = parseFloat(race.replace(/,/g, '')) / parseFloat(white.replace(/,/g, ''));
    return Math.round(ratio * 10) / 10;
  }
  // Return likelihood text
  function likelihoodText(val) {
    let modifier = '';
    if (val > 1) {
      modifier = 'more';
    } else if (val < 1) {
      modifier = 'less';
    }

    return `<span class="${modifier} times-diff">${val} times ${modifier} likely</span> than White Americans`;
  }
}
